module.exports = __webpack_public_path__ + "static/media/times_2.9f1ba4c5.svg";